<template>
  <div>
    <div class="dropdown">
      <div
        class="dropdown_select"
        @click.stop="showFilters"
      >
        <span class="selected-option"> {{ selected }}</span>
      </div>
      <svg
        class="drop-icon"
        :class="{ rotate_drop_icon: showoptions }"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 6L8 10L12 6"
          stroke="#64748B"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <div
        class="dropdown_list"
        :class="{ dropdown_list_show: showoptions }"
      >
        <div
          v-for="option in options"
          :key="option"
          class="cluster__value"
          @click="selectedOption(option)"
        >
          <div class="wrapper_dot">
            <div class="hover_item">
              {{ option }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['currentGender', 'editMode'],
  data() {
    return {
      showoptions: false,
      selected: 'Male',
      options: ['Male', 'Female', 'Not Specified'],
    };
  },
  methods: {
    showFilters() {
      
        this.showoptions = !this.showoptions;
    
    },
    selectedOption(option) {
      this.selected = option;
      this.$emit('selectedInput', this.selected);
      this.showoptions = !this.showoptions;
    },
  },
};
</script>

<style scoped>
.dropdown {
  position: relative;
  min-width: 200px;
}

.drop-icon {
  position: absolute;
  top: 0.6rem;
  right: 0.4rem;
}
.sel_cluster_val {
  letter-spacing: 0;
  line-height: 24px;
  min-height: 24px;
  white-space: nowrap;
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;

  color: #cbd5e1;
}

.rotate_drop_icon {
  transform: rotate(180deg);
}

.dropdown_list {
  z-index: 999;
  opacity: 0;
  visibility: hidden;
  position: absolute;
  transition: opacity 0.2s linear, visibility 0.2s linear, height 0.2s linear;
  background: #ffffff;
  /* Neutral / Gray 300 */
  align-items: flex-start;
  border: 0.5px solid #cbd5e1;
  /* shadow-lg */
  box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.05);
  border-radius: 5px;

  width: 201px;

  top: 2.3rem;
  height: auto;
}
.cluster__value {
  align-items: center;
  display: flex;
  flex-direction: row;

  height: 41px;
}

/* .dropdown:hover  */

.dropdown_list_show {
  opacity: 1;
  visibility: visible;
}

.dropdown_select {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  box-sizing: border-box;
  border-radius: 4px;
  height: 36px;

  margin-top: 0.3rem;
}

.selected-option {
  font-family: Inter;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  /* color: #94a3b8; */
  color: black;
  position: absolute;
  top: 0.6rem;
  left: 0.4rem;
}

.color-dot {
  width: 6px;
  height: 6px;
  /* Djuli Primary Color */
  background: #30c56f;
  margin-right: 12px;

  border-radius: 50%;
  display: inline-block;
}

.wrapper_dot {
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
}
.cluster__value:hover {
  background: #f8fafc;
}
</style>
